import React from 'react';

import './Message.css';

const Message = ({ message: { text, user }, name, key }) => {
	let isSentByCurrentUser = false;

	const trimmedName = name.trim().toLowerCase();

	if (user === trimmedName) {
		isSentByCurrentUser = true;
	}

	return isSentByCurrentUser ? (
		<div className='messageContainer justifyEnd' key={key}>
			<p className='sentText pr-10'>{trimmedName}</p>
			<div className='messageBox backgroundBlue'>
				<p className='messageText colorWhite'>{text}</p>
			</div>
		</div>
	) : (
		<div className='messageContainer justifyStart' key={key}>
			<div className='messageBox backgroundLight'>
				<p className='messageText colorDark'>{text}</p>
			</div>
			<p className='sentText pl-10'>{user}</p>
		</div>
	);
};

export default Message;
